import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getRangeValue, parseAlpha } from "./NumberUtils";
export var RgbColorManager = /*#__PURE__*/function () {
  function RgbColorManager() {
    _classCallCheck(this, RgbColorManager);

    this.key = "rgb";
    this.stringPrefix = "rgb";
  }

  _createClass(RgbColorManager, [{
    key: "handleColor",
    value: function handleColor(color) {
      var _colorValue$rgb;

      var colorValue = color.value,
          rgbColor = (_colorValue$rgb = colorValue.rgb) !== null && _colorValue$rgb !== void 0 ? _colorValue$rgb : color.value;

      if (rgbColor.r !== undefined) {
        return rgbColor;
      }
    }
  }, {
    key: "handleRangeColor",
    value: function handleRangeColor(color) {
      var _colorValue$rgb2;

      var colorValue = color.value,
          rgbColor = (_colorValue$rgb2 = colorValue.rgb) !== null && _colorValue$rgb2 !== void 0 ? _colorValue$rgb2 : color.value;

      if (rgbColor.r !== undefined) {
        return {
          r: getRangeValue(rgbColor.r),
          g: getRangeValue(rgbColor.g),
          b: getRangeValue(rgbColor.b)
        };
      }
    }
  }, {
    key: "parseString",
    value: function parseString(input) {
      if (!input.startsWith(this.stringPrefix)) {
        return;
      }

      var regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([\d.%]+)\s*)?\)/i,
          result = regex.exec(input);
      return result ? {
        a: result.length > 4 ? parseAlpha(result[5]) : 1,
        b: parseInt(result[3], 10),
        g: parseInt(result[2], 10),
        r: parseInt(result[1], 10)
      } : undefined;
    }
  }]);

  return RgbColorManager;
}();